
export const Texts = {
    SECURITY: {
        ERRORS: {
            NO_ACCESS_TOKEN: 'No access token',
            NO_REFRESH_TOKEN: 'No refresh token',
        },
    },
}